module.exports = __webpack_public_path__ + "static/media/brad.dc04a470.jpeg";